export const checksums = {
  "content_at": "v3.5.0--KNTyJzGcgsmOErRW0Hft96P-kW8XQFoutWFRtgcxiGQ",
  "content_ch": "v3.5.0--PuuOK5NnWkrNKEk9nGcMT6vjghQ_rwqe7skE3Viwmjc",
  "content_bg": "v3.5.0--UDsjRhp3qmg_o5H3wesD5-nGrrozxB1J4FQn3z0ZwyE",
  "content_cs": "v3.5.0--q9HKxPKgrLaYR0MYEqnZcgTeRA8AfD4duXmYobbRyMo",
  "content_da": "v3.5.0--V7fhpJ4QO6tRnNgRLg8RhT5h5Fv94LwJp2cVaHZrlyQ",
  "content_de": "v3.5.0--TFzZqYQRchz4XW3GvGbO4c0YvvTmdSXmsscvTNY_6iU",
  "content_en": "v3.5.0--pRWbeJM5grPBWWHY8jdnrEnBEJ9EXOIRjyl76shc63k",
  "content_es": "v3.5.0--4CuN-TGF1kqaivw8-mXO31_RPxYzHmLYfqVyvI1iAlY",
  "content_fr": "v3.5.0--0xCcHEj-D9LjzswpfNm3NdrCtT-GtNjQwdwNiNlDNas",
  "content_gb": "v3.5.0--tQDzL9EVrBXNXfSAX-9ckBLrK03A8ZNgy-UbkpJetUs",
  "content_hu": "v3.5.0--frAuQXtMnZIUzhNP45eGf3HGHea9ULFPraqsrLFtBMs",
  "content_it": "v3.5.0--1VzPeJULuy8DS5UF7s32eEoMRtS02ZZKMjpv95BwzX0",
  "content_nl": "v3.5.0--z8XcYaRKrUPV3E4lKKlPCUE612FEGJ6YPUP7L7Cyvi0",
  "content_pl": "v3.5.0--beqPjrYpl80DRNvR9w4aEvWHmWHNg_ICm21KgICMHok",
  "content_ro": "v3.5.0--Ul9GrGbMJAqdq1GzDk3VU9GwSPIXPMiojOq5fn58_TM",
  "content_sk": "v3.5.0--nCuOvSXZuX22DhkF8q9s3HBc4SruR2RAo21lXwX9knw",
  "content_uk": "v3.5.0--CftZ9cCe_Gy8_FtTwVIyTfi16v2k-JwuMBmqFTpWbdo",
  "policies_at": "v3.5.0--7nJsMZ7XV46eGgxGT04LH1BZsYoT7xayG8arRjAj514",
  "policies_bg": "v3.5.0--UD0d4CYwHxGNX49xyNL8jmA-Vro169yp6yzSgT_e3Mo",
  "policies_ch": "v3.5.0--y2slor5ejeWu6COB5N54j4DOXmqvhCqFRD0wGwEe6hg",
  "policies_cs": "v3.5.0--24lk20_60zBYD-7o9wHRz7jAb-75E74wgTih_FUFw4Y",
  "policies_da": "v3.5.0--2rFiCctr9yZKAH2jVsIQfjPvEfD0sjmN_ic3wMxW4Ac",
  "policies_de": "v3.5.0--E2dmYwX3yt8V9iJyEOdMbS8VC-1jOmJygTvDmkGTx98",
  "policies_en": "v3.5.0--Hy0VS4H2V1hKIt5GZbkJ7IrM1hPU3VJbOQQEPy75Csk",
  "policies_es": "v3.5.0--TcmJKjsbUqc9_YV5a_JUgPs52OAcardE3XNhkYCALw0",
  "policies_fr": "v3.5.0--3ZGbuBbJ7_Hksczlu-leV0LhBUqjjNOkdgA6edHWI48",
  "policies_gb": "v3.5.0--qcv8OswvVYVazJNf275q2NvVqWF4bX5OqX17NhYFLWc",
  "policies_hu": "v3.5.0--GD03vWsbB7DKbSi37gWcvG24UqmLKWbkVsEwu4Vr0sw",
  "policies_it": "v3.5.0--koIfbNpHqbMVSJ0wDxtqy5i5xt2S0FBQzhxB2ziEcrE",
  "policies_nl": "v3.5.0--pS7vo_54oVH964FLD3MJcg0fpCrmGGcIhiNIoVfDu5g",
  "policies_pl": "v3.5.0--eCr1IMsk3fFDSZoD-5A2zI4R3mnmllCI017TOVPYIVo",
  "policies_ro": "v3.5.0--Y7Pvud-y8Pct3yTCSbs_XB5R5oOA2ipvpS4ZZrs009E",
  "policies_sk": "v3.5.0--CmCcnzpTWgyizGPI5tQ0GlftQ4nN_1juHRNX0MxKNd4",
  "policies_uk": "v3.5.0---MEKAeTC1olJXjJPqFMM9Zh-H6qYoOVq1kZ-ZpCzY2g",
  "commitments_at": "v3.5.0--QUq5ZsqGDnZtZyMoygDrG21u3v4TOuo-dk-iVqDT91I",
  "commitments_bg": "v3.5.0--JYsRwhreNGYqZDv2d9Bibub4FBY1FAfhodzdazkAf64",
  "commitments_ch": "v3.5.0--OXwhjH6lIH_XXszZWORyR36WKe5HfxIzVdmIDnJTers",
  "commitments_cs": "v3.5.0--_GjXBNWTForm_07ke-91rgDOvYYYEDK2iQnqrZ7LXjg",
  "commitments_da": "v3.5.0---NhuWzGEC_qkc4sDN7r0fhLvZDBQXYP5idadIuQfPF8",
  "commitments_de": "v3.5.0--xpxw0TS_Tixr_auJ9XrsTLhys53K2Jl1sAL2ie5iQ68",
  "commitments_en": "v3.5.0--fzoanMANmhWjfaoGv40txmITPZ8AUq7cFjO-PfUR0Ew",
  "commitments_es": "v3.5.0--BfjNDOtc-PWguQj2h76-AN5bxgG3upc5Zom9OVOTa9I",
  "commitments_fr": "v3.5.0--8-V3uFmRGy0SEqViMbhV-sk6NnaKMiylIbUEi3dw-7w",
  "commitments_gb": "v3.5.0--tSO1DB5XIW0vQILhqbMNlQjZTM3RI83-3ItsaDdDYjM",
  "commitments_hu": "v3.5.0--5R1S7FbmI_oCRclWv1t8qYjl9qvtIjTBfYZjgiQQtf4",
  "commitments_it": "v3.5.0--R8XYSLKHXfZVVpvzVz-PGb5bD82p9Ugs3Bs6il8UV7Q",
  "commitments_nl": "v3.5.0--63aENSh73UTn7W5Ob07st7y6CXf5T7vZCkF4L780m7g",
  "commitments_pl": "v3.5.0--pQjs6IsxhwR8KJYmxogyeBzZF-xo5xpCUxIybQ7srf8",
  "commitments_ro": "v3.5.0--7Gh6j2NpQLlwUOoE92cGMB4D8bHIHMUunh-7VQc91GM",
  "commitments_sk": "v3.5.0--FBj7j9m8M3vF1-3WSkEnH4MVAjQ4GGvfQpU84lOKh9E",
  "commitments_uk": "v3.5.0--TFV9a5eafQr_7A8U8Od8oFQoHmznO-ZQGvDs9RUtzxo"
}
export const checksumsStructure = {
  "content_at": "V0xBveycahtpq9RpVm2ljnwx3iZ9wuSzm5GCip98j7A",
  "content_ch": "tmcKE6-bG8U8hhhdzr4N2IChKijGY679HblL9SYWcaA",
  "content_bg": "OGwBgUZRcB6BwGS_C8mA-yzL5HC1YNoxV1cWuvOlzJM",
  "content_cs": "Rs-A-T4rHRab6PoObGiQd5BrH7GLvPVzTChqmJanRoI",
  "content_da": "BmPP6nTIlufcpUJ66iB_tAfdGiZelDoPH3RtnRhWOFo",
  "content_de": "YNTynoyfg6jd8lz6LLAmd3smzySygcJXDXfsjkvkQ6Q",
  "content_en": "5QOc13PElRiLwQFVnU9C8qERKaZB24ve1gqP1Rf65Tk",
  "content_es": "2jp04T4LFcb2gPb2jUnHzhIhKJDFB8Hze7-g8cxa5wg",
  "content_fr": "_Ss3rmdFZO8T__mg-kDwvXHgc3klPNo5Cxi35_61gJw",
  "content_gb": "mI0Z2P40P1JGKNjfM8WvEs1H33QqkslbDd2AOu-q7lE",
  "content_hu": "a4skkPsjs4hjk_ljUahCipPf7lA_jBNTaABQoVvzaMg",
  "content_it": "E42UDm9HerAFhVfU7UkbvNuPUhv49NGK1_KiJELrP9o",
  "content_nl": "s8Q-yezUzMDVs9ivkWA2urRK6SK4GQYsO0ElLhNwyKQ",
  "content_pl": "U5lRAi0BQTYkwDq2DZvRt4zh6FQR58citboR3CjcyUI",
  "content_ro": "wniwHc777TbWaygMDMADopyyoCDXqPkWhOJUDeUKIIo",
  "content_sk": "YnfBUeW2UHh7P5gQEkrblkLJS5pr7LcZkOXtm-hIRAQ",
  "content_uk": "GQ0KQ2SwKaZUrUt94T_U6URrSgsOaBfzSt8T6XUCfv0",
  "policies_at": "0CHUkb6tHClOW_Btat0pg8F46vzOoSFvYomvQ45w_tQ",
  "policies_bg": "BPdRVgvtVbFI02qRD7k51tseexGujVjkINRr0LfNNLU",
  "policies_ch": "7vyw8K-fu2NI5Y3iS4CjRMgwdU6n6ilY4c4r6AOAA-g",
  "policies_cs": "6t9Cz31pzumK-8dInu8Entjg9ARi-GZ1OrKT5TW271Y",
  "policies_da": "5GVHoOc5gVv0Du-_RalcvN9YAbqizAb7p212RW6GIuc",
  "policies_de": "HMxXjDBlMukBZNPxc1NY3T1C76bWmWZ7MfG5yidJu1M",
  "policies_en": "3o2y6Kbig3UYZLrUzwAL6Yr3X8BdFIl_hBWjg-u26T0",
  "policies_es": "CdC6nAvMZXB0OJ-nVl538aleS0Y5-tASgXpyPgME_yU",
  "policies_fr": "YyBkizcwA0g4Umu6YmcM6sNzYJu8jQYJmwk4mTW1nyo",
  "policies_gb": "ZZIgmld2mVeexcaWFoMX4eMI0dgQdb2RULvOHayuLGQ",
  "policies_hu": "5D2IVtSbhZzgBsyZ4pAZZDz_r2lUMRTU4CPJ596acnA",
  "policies_it": "KxBrlS3f-XjaHeZ8fvP8oJReab_NFS66JK-Ix4Q9HBY",
  "policies_nl": "s-sefZHJfFSCIJtt7OmY1-htr0NzMFAXm0mvuQkySgA",
  "policies_pl": "UZVyf5ZICRi2EcQk1M7kVAYApnFclWQm9lGsA028R6g",
  "policies_ro": "W2FoIuTejb78cetcDEv7BWZTE1311zobRpqOmYqSK_Q",
  "policies_sk": "pRKCADvFOA--oAOkZCXpYHbPE-RD8nHaMEQVgcEeoTg",
  "policies_uk": "fYMqggdDm_Blt7UhHZAdxiQq4oFdpduUuH3lvKo-Z4c",
  "commitments_at": "UCUWa8dCtxHsZ_Mr5hYjvpp2_GmJTf9FepMjDwhCxiY",
  "commitments_bg": "STEftDVPKH9zJayUE-5eIvQOLMT8rA9jc6A8H0KDJKA",
  "commitments_ch": "Yl_6-l1NTokOOfUVE6vhUTktrDtilMfR2_KhPFiazxM",
  "commitments_cs": "cmHq9-0OPY_jFZLCs9Uip5dImBnX98J0bh_nW5KW6hE",
  "commitments_da": "_mf7cmKTWr6G5Arep_QlArjULs0EHoRz4vcUam8PwJw",
  "commitments_de": "XQwolAxJZ_oAQ62_pH2GwSD9RCcfHKMhZN6NDqBbXGI",
  "commitments_en": "3FiYz5ZtLK5WHWtv1ILaFMk6tB319b3W3FUVg0iXNPk",
  "commitments_es": "962fRN3vm0bHFJ_IuWBcsK_1lN_0HFyQxlkcRCNGv8s",
  "commitments_fr": "6ixDhwGlfdk9VfOOvyt6BsWRlDijwOEd4UtN3hbA1Xs",
  "commitments_gb": "PZ2aQcf0P_hDzeYm-r5-zIBG0rcGyImygjAedpa70m4",
  "commitments_hu": "8xd4v6RkunBJwRoi5gZtSPW5udwrCjQJVu99z7C-qlU",
  "commitments_it": "Xp_5tlTtftMWhpv65GODlJRyax96OMuil-NHgszmJcw",
  "commitments_nl": "PeoUS5E7e-wC4RJRq7kYdP3HvZjqkX_6nSuMZ3fgHS0",
  "commitments_pl": "Z-PcHuUzpZQUMHQ6RSbi-uzvXGwusEj_nD9Dkw-5n28",
  "commitments_ro": "A5Uv9w10h7tCUQb9qs37MaQWlkYUtOMDzp6zOg_EHgc",
  "commitments_sk": "AH3Ci8Qd0UAszyBaOm2d1-8RJ-usUmI9seDDp-wvPdY",
  "commitments_uk": "cp2JQLM9fcNCIg80Oc0Dtb-P7olTrjPK7_PMxXbqEGI"
}

export const tables = {
  "content_at": "_content_content_at",
  "content_ch": "_content_content_ch",
  "content_bg": "_content_content_bg",
  "content_cs": "_content_content_cs",
  "content_da": "_content_content_da",
  "content_de": "_content_content_de",
  "content_en": "_content_content_en",
  "content_es": "_content_content_es",
  "content_fr": "_content_content_fr",
  "content_gb": "_content_content_gb",
  "content_hu": "_content_content_hu",
  "content_it": "_content_content_it",
  "content_nl": "_content_content_nl",
  "content_pl": "_content_content_pl",
  "content_ro": "_content_content_ro",
  "content_sk": "_content_content_sk",
  "content_uk": "_content_content_uk",
  "policies_at": "_content_policies_at",
  "policies_bg": "_content_policies_bg",
  "policies_ch": "_content_policies_ch",
  "policies_cs": "_content_policies_cs",
  "policies_da": "_content_policies_da",
  "policies_de": "_content_policies_de",
  "policies_en": "_content_policies_en",
  "policies_es": "_content_policies_es",
  "policies_fr": "_content_policies_fr",
  "policies_gb": "_content_policies_gb",
  "policies_hu": "_content_policies_hu",
  "policies_it": "_content_policies_it",
  "policies_nl": "_content_policies_nl",
  "policies_pl": "_content_policies_pl",
  "policies_ro": "_content_policies_ro",
  "policies_sk": "_content_policies_sk",
  "policies_uk": "_content_policies_uk",
  "commitments_at": "_content_commitments_at",
  "commitments_bg": "_content_commitments_bg",
  "commitments_ch": "_content_commitments_ch",
  "commitments_cs": "_content_commitments_cs",
  "commitments_da": "_content_commitments_da",
  "commitments_de": "_content_commitments_de",
  "commitments_en": "_content_commitments_en",
  "commitments_es": "_content_commitments_es",
  "commitments_fr": "_content_commitments_fr",
  "commitments_gb": "_content_commitments_gb",
  "commitments_hu": "_content_commitments_hu",
  "commitments_it": "_content_commitments_it",
  "commitments_nl": "_content_commitments_nl",
  "commitments_pl": "_content_commitments_pl",
  "commitments_ro": "_content_commitments_ro",
  "commitments_sk": "_content_commitments_sk",
  "commitments_uk": "_content_commitments_uk",
  "info": "_content_info"
}

export default {
  "content_at": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_ch": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_bg": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_cs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_da": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_de": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_es": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_fr": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_gb": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_hu": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_it": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_nl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_pl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_ro": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_sk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "content_uk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_at": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_bg": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_ch": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_cs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_da": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_de": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_es": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_fr": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_gb": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_hu": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_it": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_nl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_pl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_ro": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_sk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "policies_uk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_at": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_bg": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_ch": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_cs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_da": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_de": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_es": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_fr": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_gb": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_hu": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_it": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_nl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_pl": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_ro": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_sk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "commitments_uk": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}